"use strict";

(self.webpackChunkshopify_template = self.webpackChunkshopify_template || []).push([ [ 982 ], {
  895: function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
    __webpack_require__.d(__webpack_exports__, {
      qh: function() {
        return FilterManager;
      },
      _d: function() {
        return config_KlevuConfig;
      },
      IZ: function() {
        return klevuFetch_KlevuFetch;
      },
      I$: function() {
        return KlevuSearchSorting_KlevuSearchSorting;
      },
      Cq: function() {
        return KlevuTypeOfRecord_KlevuTypeOfRecord;
      },
      CI: function() {
        return applyFilterWithManager;
      },
      I1: function() {
        return listFilters;
      },
      $P: function() {
        return search;
      },
      xe: function() {
        return searchCategory;
      },
      GN: function() {
        return searchCms;
      },
      Tp: function() {
        return sendSearchEvent;
      },
      Gn: function() {
        return suggestions;
      },
      yI: function() {
        return trendingProducts;
      }
    });
    var __awaiter = function(thisArg, _arguments, P, generator) {
      return new (P || (P = Promise))((function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator.throw(value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          var value;
          result.done ? resolve(result.value) : (value = result.value, value instanceof P ? value : new P((function(resolve) {
            resolve(value);
          }))).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      }));
    };
    function fetch_get(url, ignoreResult = !1) {
      return __awaiter(this, void 0, void 0, (function*() {
        const axios = config_KlevuConfig.getDefault().axios;
        if (axios) return (yield axios.get(url)).data;
        const res = yield fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        });
        return ignoreResult ? void 0 : yield res.json();
      }));
    }
    function fetch_post(url, data, ignoreResult = !1) {
      return __awaiter(this, void 0, void 0, (function*() {
        const sendAsFormData = data instanceof FormData, axios = config_KlevuConfig.getDefault().axios;
        if (axios) try {
          return (yield axios.post(url, data, {
            headers: sendAsFormData ? void 0 : {
              "Content-Type": "application/json"
            }
          })).data;
        } catch (error) {
          return error.response.data;
        }
        const res = yield fetch(url, {
          method: "POST",
          headers: sendAsFormData ? void 0 : {
            "Content-Type": "application/json"
          },
          body: sendAsFormData ? data : JSON.stringify(data)
        });
        if (!ignoreResult) return yield res.json();
      }));
    }
    var _a, StorageType, utils_isBrowser = __webpack_require__(345);
    !function(StorageType) {
      StorageType.SESSION = "session", StorageType.LOCAL = "local";
    }(StorageType || (StorageType = {}));
    const isSessionStorage = storageType => storageType === StorageType.SESSION && "undefined" != typeof window && window.sessionStorage, isLocalStorage = storageType => storageType === StorageType.LOCAL && "undefined" != typeof window && window.localStorage;
    class storage_KlevuStorage {
      static listKeys() {
        return this.dataProtectedKeys;
      }
    }
    _a = storage_KlevuStorage, storage_KlevuStorage.dataProtectedKeys = [], storage_KlevuStorage.addKey = key => {
      _a.dataProtectedKeys.find((k => k === key)) || _a.dataProtectedKeys.push(key);
    }, storage_KlevuStorage.removeKey = key => {
      const keyIndex = _a.dataProtectedKeys.indexOf(key);
      -1 !== keyIndex && _a.dataProtectedKeys.splice(keyIndex, 1);
    }, storage_KlevuStorage.getItem = (key, storageType = StorageType.LOCAL) => void 0 !== _a.dataProtectedKeys.find((k => k.includes(key))) && config_KlevuConfig.getDefault().isConsentDisallowed() ? null : isLocalStorage(storageType) ? window.localStorage.getItem(key) : isSessionStorage(storageType) ? window.sessionStorage.getItem(key) : null, 
    storage_KlevuStorage.setItem = (key, value, storageType = StorageType.LOCAL) => {
      if (void 0 === _a.dataProtectedKeys.find((k => k.includes(key))) || !config_KlevuConfig.getDefault().isConsentDisallowed()) return isLocalStorage(storageType) ? window.localStorage.setItem(key, value) : isSessionStorage(storageType) ? window.sessionStorage.setItem(key, value) : void 0;
    }, storage_KlevuStorage.removeItem = (key, storageType = StorageType.LOCAL) => {
      if (void 0 === _a.dataProtectedKeys.find((k => k.includes(key))) || !config_KlevuConfig.getDefault().isConsentDisallowed()) return isLocalStorage(storageType) ? window.localStorage.removeItem(key) : isSessionStorage(storageType) ? window.sessionStorage.removeItem(key) : void 0;
    };
    var eventRequests_awaiter = function(thisArg, _arguments, P, generator) {
      return new (P || (P = Promise))((function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator.throw(value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          var value;
          result.done ? resolve(result.value) : (value = result.value, value instanceof P ? value : new P((function(resolve) {
            resolve(value);
          }))).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      }));
    }, __asyncValues = function(o) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var i, m = o[Symbol.asyncIterator];
      return m ? m.call(o) : (o = "function" == typeof __values ? __values(o) : o[Symbol.iterator](), 
      i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
      }, i);
      function verb(n) {
        i[n] = o[n] && function(v) {
          return new Promise((function(resolve, reject) {
            (function(resolve, reject, d, v) {
              Promise.resolve(v).then((function(v) {
                resolve({
                  value: v,
                  done: d
                });
              }), reject);
            })(resolve, reject, (v = o[n](v)).done, v.value);
          }));
        };
      }
    };
    const KEY_PENDING_REQUESTS = "klevu-pending-analytics";
    function KlevuEventV2(data) {
      return eventRequests_awaiter(this, void 0, void 0, (function*() {
        const url = config_KlevuConfig.getDefault().eventsApiV2Url, id = addPendingRequest(url, data), res = yield fetch_post(url, data, !0);
        return id && removePendingRequest(id), res;
      }));
    }
    function sendGenericPostEvent(url, data) {
      return eventRequests_awaiter(this, void 0, void 0, (function*() {
        const formData = new FormData;
        for (const key in data) void 0 !== data[key] && (Array.isArray(data[key]) ? data[key].forEach((d => {
          formData.append(key, d);
        })) : formData.append(key, data[key]));
        if (!((0, utils_isBrowser.B)() && navigator.sendBeacon && navigator.sendBeacon(url, formData))) return yield fetch_post(url, formData, !0);
      }));
    }
    function addPendingRequest(url, data) {
      if (!(0, utils_isBrowser.B)()) return;
      let requests = [];
      const old = storage_KlevuStorage.getItem(KEY_PENDING_REQUESTS, StorageType.SESSION);
      if (old) try {
        requests = JSON.parse(old);
      } catch (_a) {
        storage_KlevuStorage.removeItem(KEY_PENDING_REQUESTS, StorageType.SESSION);
      }
      const id = function() {
        let firstPart = 46656 * Math.random() | 0, secondPart = 46656 * Math.random() | 0;
        return firstPart = ("000" + firstPart.toString(36)).slice(-3), secondPart = ("000" + secondPart.toString(36)).slice(-3), 
        firstPart + secondPart;
      }();
      return requests.push({
        id: id,
        url: url,
        data: data
      }), storage_KlevuStorage.setItem(KEY_PENDING_REQUESTS, JSON.stringify(requests), StorageType.SESSION), 
      id;
    }
    function removePendingRequest(id) {
      if (!(0, utils_isBrowser.B)()) return;
      const data = storage_KlevuStorage.getItem(KEY_PENDING_REQUESTS, StorageType.SESSION);
      if (data) try {
        const requests = JSON.parse(data);
        requests.splice(requests.findIndex((r => r.id === id)), 1), storage_KlevuStorage.setItem(KEY_PENDING_REQUESTS, JSON.stringify(requests), StorageType.SESSION);
      } catch (e) {
        console.error("Failed to save pending request");
      } else console.error("No pending requests!");
    }
    function cleanSearchQuery(term) {
      return term.replace(/\s{2,}/g, " ").replace(/\s\s+/g, " ").trim().toLocaleLowerCase();
    }
    class Klaviyo {
      constructor() {
        this.timer = null;
      }
      setExchangeId() {
        var _a;
        if (!globalThis._learnq) return void (this.timer || (this.timer = setInterval((() => {
          this.setExchangeId();
        }), 300)));
        const _getIdentifiersResponse = null === (_a = globalThis._learnq) || void 0 === _a ? void 0 : _a.push([ "_getIdentifiers", "", {} ]);
        this.exchangeId = _getIdentifiersResponse.$exchange_id, this.exchangeId ? (this.timer && clearInterval(this.timer), 
        usersession_KlevuUserSession.getDefault().generateSession()) : this.timer || (this.timer = setInterval((() => {
          this.setExchangeId();
        }), 300));
      }
      static init() {
        Klaviyo.default = new Klaviyo, this.getDefault().setExchangeId();
      }
      static getDefault() {
        if (!Klaviyo.default) throw new Error("Klaviyo not initialized.");
        return Klaviyo.default;
      }
      getExchangeId() {
        return this.exchangeId;
      }
      static generatePayload() {
        if (config_KlevuConfig.getDefault().enableKlaviyoConnector && this.default && this.getDefault().exchangeId) return {
          connectorType: "klaviyo",
          exchangeId: this.getDefault().exchangeId || ""
        };
      }
    }
    var usersession_awaiter = function(thisArg, _arguments, P, generator) {
      return new (P || (P = Promise))((function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator.throw(value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          var value;
          result.done ? resolve(result.value) : (value = result.value, value instanceof P ? value : new P((function(resolve) {
            resolve(value);
          }))).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      }));
    };
    const connectors = [ {
      name: "klaviyo",
      connector: Klaviyo
    } ];
    class usersession_KlevuUserSession {
      constructor() {
        this.timer = null, this.getSessionId = () => usersession_awaiter(this, void 0, void 0, (function*() {
          const apiKey = config_KlevuConfig.getDefault().apiKey, sessionInfo = {
            connectorInfo: connectors.map((({connector: connector}) => {
              try {
                return connector.generatePayload();
              } catch (_a) {
                return;
              }
            })).filter((connector => connector))
          }, payload = {
            apiKey: apiKey,
            sessionId: this.sessionId || void 0,
            sessionInfo: sessionInfo
          };
          return fetch_post(`${config_KlevuConfig.getDefault().visitorServiceUrl}/${apiKey}/session`, payload);
        })), storage_KlevuStorage.addKey("klevu-user-sessionId"), storage_KlevuStorage.addKey("klevu-user-session_expiry"), 
        storage_KlevuStorage.addKey("klevu-user-segmentInfo"), this.expiry = storage_KlevuStorage.getItem("klevu-user-session_expiry");
        const segmentInfo = storage_KlevuStorage.getItem("klevu-user-segmentInfo");
        this.segmentInfo = segmentInfo ? JSON.parse(segmentInfo) : null, this.sessionId = storage_KlevuStorage.getItem("klevu-user-sessionId");
      }
      static init() {
        usersession_KlevuUserSession.default || (usersession_KlevuUserSession.default = new usersession_KlevuUserSession);
      }
      static getDefault() {
        if (!usersession_KlevuUserSession.default) throw new Error("KlevuUserSession not initialized.");
        return usersession_KlevuUserSession.default;
      }
      hasSessionExpired() {
        return !this.sessionId || !this.expiry || Date.now() > +this.expiry;
      }
      generateSession() {
        return usersession_awaiter(this, void 0, void 0, (function*() {
          const sessionInfo = yield this.getSessionId();
          if (sessionInfo) {
            if (storage_KlevuStorage.setItem("klevu-user-sessionId", sessionInfo.sessionId), 
            this.sessionId = sessionInfo.sessionId, sessionInfo.segmentInfo) {
              storage_KlevuStorage.setItem("klevu-user-segmentInfo", JSON.stringify(sessionInfo.segmentInfo)), 
              this.segmentInfo = sessionInfo.segmentInfo;
              const expiry = Date.now() + (sessionInfo.segmentInfo.ttl ? 1e3 * sessionInfo.segmentInfo.ttl : 0);
              storage_KlevuStorage.setItem("klevu-user-session_expiry", expiry.toString()), this.expiry = expiry.toString(), 
              this.timer && clearTimeout(this.timer), this.timer = setTimeout((() => {
                this.generateSession();
              }), 1e3 * sessionInfo.segmentInfo.ttl);
            }
          } else console.warn("Failed to generate user session");
        }));
      }
      setExpiryTimer() {
        const currentTime = Date.now(), expiry = +(this.expiry || currentTime) - currentTime;
        this.timer && clearTimeout(this.timer), this.timer = setTimeout((() => {
          this.generateSession();
        }), expiry);
      }
      getSegments() {
        var _a;
        return (null === (_a = this.segmentInfo) || void 0 === _a ? void 0 : _a.segments) || [];
      }
    }
    var KlevuDomEvents;
    !function(KlevuDomEvents) {
      KlevuDomEvents.LastSearchUpdate = "klevu-last-search-update", KlevuDomEvents.FilterSelectionUpdate = "klevu-filter-selection-updates", 
      KlevuDomEvents.FiltersApplied = "klevu-filters-applied", KlevuDomEvents.ClickEventSent = "klevu-click-event-sent", 
      KlevuDomEvents.UserConsentGivenChanged = "klevu-user-consent-given-changed", KlevuDomEvents.UseConsentChanged = "klevu-use-consent-changed";
    }(KlevuDomEvents || (KlevuDomEvents = {}));
    var ipresolver_awaiter = function(thisArg, _arguments, P, generator) {
      return new (P || (P = Promise))((function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator.throw(value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          var value;
          result.done ? resolve(result.value) : (value = result.value, value instanceof P ? value : new P((function(resolve) {
            resolve(value);
          }))).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      }));
    };
    class KlevuIpResolver {
      constructor() {
        this.timer = null, this.getIPData = () => ipresolver_awaiter(this, void 0, void 0, (function*() {
          let ipV4Response, ipV6Response;
          try {
            const ipV4Payload = {
              klevu_uuid: this.uuid || ""
            };
            ipV4Response = yield fetch_post(config_KlevuConfig.getDefault().ipv4ServiceUrl, ipV4Payload);
          } catch (err) {
            console.info(err);
          }
          try {
            const ipV6Payload = {
              klevu_uuid: (null == ipV4Response ? void 0 : ipV4Response.klevu_uuid) || ""
            };
            ipV6Response = yield fetch_post(config_KlevuConfig.getDefault().ipv6ServiceUrl, ipV6Payload);
          } catch (err) {
            console.info(err);
          }
          return {
            uuid: (null == ipV4Response ? void 0 : ipV4Response.klevu_uuid) || (null == ipV6Response ? void 0 : ipV6Response.klevu_uuid) || "",
            ipv4: (null == ipV4Response ? void 0 : ipV4Response.ip_address) || "",
            ipv6: (null == ipV6Response ? void 0 : ipV6Response.ip_address) || ""
          };
        })), storage_KlevuStorage.addKey("klevu-user-v4-id"), storage_KlevuStorage.addKey("klevu-user-v6-id"), 
        storage_KlevuStorage.addKey("klevu-user-v4-v6-expiry"), storage_KlevuStorage.addKey("klevu-user-uuid"), 
        this.expiry = storage_KlevuStorage.getItem("klevu-user-v4-v6-expiry"), this.uuid = storage_KlevuStorage.getItem("klevu-user-uuid"), 
        this.ipv4 = storage_KlevuStorage.getItem("klevu-user-v4-id"), this.ipv6 = storage_KlevuStorage.getItem("klevu-user-v6-id");
      }
      static init() {
        KlevuIpResolver.default || (KlevuIpResolver.default = new KlevuIpResolver);
      }
      static getDefault() {
        if (!KlevuIpResolver.default) throw new Error("KlevuIpResolver not initialized.");
        return KlevuIpResolver.default;
      }
      hasIPInfoExpired() {
        return !(this.uuid && this.ipv4 && this.ipv6 && this.expiry) || Date.now() > +this.expiry;
      }
      generateIPData() {
        return ipresolver_awaiter(this, void 0, void 0, (function*() {
          try {
            const ipData = yield this.getIPData();
            storage_KlevuStorage.setItem("klevu-user-v4-id", ipData.ipv4), storage_KlevuStorage.setItem("klevu-user-v6-id", ipData.ipv6), 
            storage_KlevuStorage.setItem("klevu-user-uuid", ipData.uuid), this.uuid = ipData.uuid, 
            this.ipv4 = ipData.ipv4, this.ipv6 = ipData.ipv6;
            const expiry = Date.now() + 36e5;
            storage_KlevuStorage.setItem("klevu-user-v4-v6-expiry", expiry.toString()), this.expiry = expiry.toString(), 
            this.timer && clearTimeout(this.timer), this.timer = setTimeout((() => {
              this.generateIPData();
            }), 36e5);
          } catch (err) {
            console.error("Failed to generate ip data", err), this.timer = setTimeout((() => {
              this.generateIPData();
            }), 36e5);
          }
        }));
      }
      setExpiryTimer() {
        const currentTime = Date.now(), expiry = +(this.expiry || currentTime) - currentTime;
        this.timer && clearTimeout(this.timer), this.timer = setTimeout((() => {
          this.generateIPData();
        }), expiry);
      }
      getUserData() {
        return config_KlevuConfig.getDefault().isConsentDisallowed() ? {} : {
          ipv4: storage_KlevuStorage.getItem("klevu-user-v4-id") || "",
          ipv6: storage_KlevuStorage.getItem("klevu-user-v6-id") || "",
          uuid: storage_KlevuStorage.getItem("klevu-user-uuid") || ""
        };
      }
    }
    class config_KlevuConfig {
      constructor(config) {
        var _a;
        this.cacheMaxTTL = 6e5, this.eventsApiV1Url = "https://stats.ksearchnet.com/analytics/", 
        this.eventsApiV2Url = "https://stats.ksearchnet.com/analytics/collect", this.recommendationsApiUrl = "https://config-cdn.ksearchnet.com/recommendations/", 
        this.visitorServiceUrl = "https://visitor.service.ksearchnet.com/public/1.0", this.ipv6ServiceUrl = "https://ipv6check.ksearchnet.com", 
        this.ipv4ServiceUrl = "https://ipv4check.ksearchnet.com", this.moiApiUrl = "https://moi-ai.ksearchnet.com/", 
        this.disableClickTracking = !1, this.enableKlaviyoConnector = !1, this.useConsent = !1, 
        this.consentGiven = !1, this.disableUserSession = !1, this.apiKey = config.apiKey, 
        this.url = config.url, config.moiApiUrl && (this.moiApiUrl = config.moiApiUrl), 
        config.cacheMaxTTL && (this.cacheMaxTTL = config.cacheMaxTTL), config.axios && (this.axios = config.axios.create()), 
        config.eventsApiV1Url && (this.eventsApiV1Url = config.eventsApiV1Url), config.eventsApiV2Url && (this.eventsApiV2Url = config.eventsApiV2Url), 
        config.visitorServiceUrl && (this.visitorServiceUrl = config.visitorServiceUrl), 
        config.ipv4ServiceUrl && (this.ipv4ServiceUrl = config.ipv4ServiceUrl), config.ipv6ServiceUrl && (this.ipv6ServiceUrl = config.ipv6ServiceUrl), 
        config.recommendationsApiUrl && (this.recommendationsApiUrl = config.recommendationsApiUrl), 
        this.disableClickTracking = null !== (_a = config.disableClickTrackStoring) && void 0 !== _a && _a, 
        this.useConsent = config.useConsent || !1, this.consentGiven = config.consentGiven || !1, 
        this.enableKlaviyoConnector = config.enableKlaviyoConnector || !1, this.disableUserSession = config.disableUserSession || !1;
      }
      static init(config) {
        config_KlevuConfig.default = new config_KlevuConfig(config), function() {
          var _a, e_1, _b, _c;
          eventRequests_awaiter(this, void 0, void 0, (function*() {
            if (!(0, utils_isBrowser.B)()) return;
            const data = storage_KlevuStorage.getItem(KEY_PENDING_REQUESTS, StorageType.SESSION);
            if (!data) return;
            const requests = JSON.parse(data);
            try {
              for (var requests_1_1, _d = !0, requests_1 = __asyncValues(requests); requests_1_1 = yield requests_1.next(), 
              !(_a = requests_1_1.done); _d = !0) {
                _c = requests_1_1.value, _d = !1;
                const request = _c;
                try {
                  request.data ? yield sendGenericPostEvent(request.url, request.data) : yield fetch_get(request.url, !0), 
                  removePendingRequest(request.id);
                } catch (e) {}
              }
            } catch (e_1_1) {
              e_1 = {
                error: e_1_1
              };
            } finally {
              try {
                _d || _a || !(_b = requests_1.return) || (yield _b.call(requests_1));
              } finally {
                if (e_1) throw e_1.error;
              }
            }
          }));
        }(), config.disableUserSession || this.initializeUserSession(), this.initializeIPResolver();
      }
      static initializeIPResolver() {
        KlevuIpResolver.init(), KlevuIpResolver.getDefault().hasIPInfoExpired() ? KlevuIpResolver.getDefault().generateIPData() : KlevuIpResolver.getDefault().setExpiryTimer();
      }
      static initializeUserSession() {
        usersession_KlevuUserSession.init(), usersession_KlevuUserSession.getDefault().hasSessionExpired() ? usersession_KlevuUserSession.getDefault().generateSession().then((() => {
          this.getDefault().enableKlaviyoConnector && Klaviyo.init();
        })) : (usersession_KlevuUserSession.getDefault().setExpiryTimer(), this.getDefault().enableKlaviyoConnector && Klaviyo.init());
      }
      static getDefault() {
        if (!config_KlevuConfig.default) throw new Error("Configuration missing");
        return config_KlevuConfig.default;
      }
      isConsentDisallowed() {
        return this.useConsent && !this.consentGiven;
      }
      setUseConsent(useConsent) {
        this.useConsent = useConsent, "undefined" != typeof document && document.dispatchEvent(new CustomEvent(KlevuDomEvents.UseConsentChanged, {
          detail: {
            useConsent: useConsent
          }
        }));
      }
      setEnableKlaviyoConnector(val) {
        this.enableKlaviyoConnector = val, val && Klaviyo.init();
      }
      setConsentGiven(userConsent) {
        this.consentGiven = userConsent, userConsent && (usersession_KlevuUserSession.getDefault().generateSession(), 
        KlevuIpResolver.getDefault().generateIPData()), "undefined" != typeof document && document.dispatchEvent(new CustomEvent(KlevuDomEvents.UserConsentGivenChanged, {
          detail: {
            userConsent: userConsent
          }
        }));
      }
    }
    var KlevuFilterType, AdvancedSortingDiretion, KlevuFilterOrder, KlevuSearchPreference_KlevuSearchPreference, KlevuSearchSorting_KlevuSearchSorting, KlevuTypeOfRecord_KlevuTypeOfRecord, KlevuTypeOfRequest_KlevuTypeOfRequest, KlevuTypeOfSearch;
    config_KlevuConfig.default = function() {
      if (!(0, utils_isBrowser.B)()) return;
      const cfg = window.KlevuConfig;
      if (!cfg) return;
      return new config_KlevuConfig(cfg);
    }(), function(KlevuFilterType) {
      KlevuFilterType.Options = "OPTIONS", KlevuFilterType.Slider = "SLIDER", KlevuFilterType.Rating = "RATING";
    }(KlevuFilterType || (KlevuFilterType = {})), function(AdvancedSortingDiretion) {
      AdvancedSortingDiretion.Ascending = "ASC", AdvancedSortingDiretion.Descending = "DESC";
    }(AdvancedSortingDiretion || (AdvancedSortingDiretion = {})), function(KlevuFilterOrder) {
      KlevuFilterOrder.Frequency = "FREQ", KlevuFilterOrder.Index = "INDEX";
    }(KlevuFilterOrder || (KlevuFilterOrder = {})), function(KlevuSearchPreference) {
      KlevuSearchPreference.showOutOfStockProducts = "showOutOfStockProducts", KlevuSearchPreference.hideOutOfStockProducts = "hideOutOfStockProducts", 
      KlevuSearchPreference.disableStockSorting = "disableStockSorting", KlevuSearchPreference.includeStopwords = "includeStopwords", 
      KlevuSearchPreference.excludeIds = "excludeIds", KlevuSearchPreference.includeDescription = "includeDescription", 
      KlevuSearchPreference.disableFuzzyMatch = "disableFuzzyMatch", KlevuSearchPreference.disableWildcard = "disableWildcard", 
      KlevuSearchPreference.disableORSearch = "disableORSearch", KlevuSearchPreference.partialMatch = "partialMatch", 
      KlevuSearchPreference.partialMatchForAllWords = "partialMatchForAllWords", KlevuSearchPreference.disableWordShingles = "disableWordShingles", 
      KlevuSearchPreference.searchCompoundsAsAndQuery = "searchCompoundsAsAndQuery", KlevuSearchPreference.enableBoostingOriginalTermsInSynonyms = "enableBoostingOriginalTermsInSynonyms", 
      KlevuSearchPreference.showDisabledFacets = "showDisabledFacets", KlevuSearchPreference.showFiltersWithSmallCount = "showFiltersWithSmallCount", 
      KlevuSearchPreference.includeCategoryFilterInCatNav = "includeCategoryFilterInCatNav", 
      KlevuSearchPreference.enableScores = "enableScores", KlevuSearchPreference.debugQuery = "debugQuery", 
      KlevuSearchPreference.ignoreManualBoosting = "ignoreManualBoosting";
    }(KlevuSearchPreference_KlevuSearchPreference || (KlevuSearchPreference_KlevuSearchPreference = {})), 
    function(KlevuSearchSorting) {
      KlevuSearchSorting.Relevance = "RELEVANCE", KlevuSearchSorting.PriceAsc = "PRICE_ASC", 
      KlevuSearchSorting.PriceDesc = "PRICE_DESC", KlevuSearchSorting.NameAsc = "NAME_ASC", 
      KlevuSearchSorting.NameDesc = "NAME_DESC", KlevuSearchSorting.RatingAsc = "RATING_ASC", 
      KlevuSearchSorting.RatingDesc = "RATING_DESC", KlevuSearchSorting.NewArrivalAsc = "NEW_ARRIVAL_ASC", 
      KlevuSearchSorting.NewArrivalDesc = "NEW_ARRIVAL_DESC", KlevuSearchSorting.AdvancedSorting = "ADVANCED_SORT";
    }(KlevuSearchSorting_KlevuSearchSorting || (KlevuSearchSorting_KlevuSearchSorting = {})), 
    function(KlevuTypeOfRecord) {
      KlevuTypeOfRecord.Product = "KLEVU_PRODUCT", KlevuTypeOfRecord.Cms = "KLEVU_CMS", 
      KlevuTypeOfRecord.Category = "KLEVU_CATEGORY", KlevuTypeOfRecord.Image = "KLEVU_IMAGE";
    }(KlevuTypeOfRecord_KlevuTypeOfRecord || (KlevuTypeOfRecord_KlevuTypeOfRecord = {})), 
    function(KlevuTypeOfRequest) {
      KlevuTypeOfRequest.Search = "SEARCH", KlevuTypeOfRequest.Suggestion = "AUTO_SUGGESTIONS", 
      KlevuTypeOfRequest.CategoryNavigation = "CATNAV", KlevuTypeOfRequest.NewArrivals = "RECS_NEW_ARRIVALS", 
      KlevuTypeOfRequest.SimilarProducts = "RECS_SIMILAR", KlevuTypeOfRequest.Trending = "RECS_TRENDING", 
      KlevuTypeOfRequest.AlsoViewed = "RECS_ALSO_VIEWED", KlevuTypeOfRequest.AlsoBought = "RECS_ALSO_BOUGHT", 
      KlevuTypeOfRequest.VisuallySimilar = "RECS_SIMILAR_IMAGES", KlevuTypeOfRequest.Custom = "RECS_CUSTOM", 
      KlevuTypeOfRequest.Skip = "SKIP";
    }(KlevuTypeOfRequest_KlevuTypeOfRequest || (KlevuTypeOfRequest_KlevuTypeOfRequest = {})), 
    function(KlevuTypeOfSearch) {
      KlevuTypeOfSearch.Default = "DEFAULT", KlevuTypeOfSearch.WildcardAnd = "WILDCARD_AND", 
      KlevuTypeOfSearch.FuzzyAnd = "FUZZY_AND", KlevuTypeOfSearch.WildcardOr = "WILDCARD_OR", 
      KlevuTypeOfSearch.FuzzyOr = "FUZZY_OR", KlevuTypeOfSearch.And = "AND", KlevuTypeOfSearch.Or = "OR";
    }(KlevuTypeOfSearch || (KlevuTypeOfSearch = {}));
    function notEmpty_notEmpty(value) {
      return null != value;
    }
    const lastClickedProducts_KlevuLastClickedProducts = new class {
      save() {
        config_KlevuConfig.getDefault().disableClickTracking || (0, utils_isBrowser.B)() && window.localStorage && storage_KlevuStorage.setItem("klevu-last-clicks", JSON.stringify(this.clicks));
      }
      saveCat() {
        config_KlevuConfig.getDefault().disableClickTracking || (0, utils_isBrowser.B)() && window.sessionStorage && this.categoryCache && storage_KlevuStorage.setItem("klevu-last-clicks-cat", JSON.stringify(this.categoryCache), StorageType.SESSION);
      }
      restore() {
        if ((0, utils_isBrowser.B)() && window.localStorage) {
          const res = storage_KlevuStorage.getItem("klevu-last-clicks");
          res && (this.clicks = JSON.parse(res));
        }
        if ((0, utils_isBrowser.B)() && window.localStorage) {
          const resCat = storage_KlevuStorage.getItem("klevu-last-clicks-cat", StorageType.LOCAL);
          resCat && (this.categoryCache = JSON.parse(resCat));
        }
      }
      constructor() {
        this.categoryCache = null, this.clicks = [], this.restore();
      }
      click(productId, product) {
        if (storage_KlevuStorage.addKey("klevu-last-clicks"), config_KlevuConfig.getDefault().disableClickTracking) return;
        const lastIndex = this.clicks.findIndex((ls => ls.id === productId));
        lastIndex > -1 && this.clicks.splice(lastIndex, 1), this.clicks.push({
          ts: new Date,
          id: productId,
          product: product
        }), this.clicks.length > 20 && (this.clicks = this.clicks.slice(-20)), this.save(), 
        (0, utils_isBrowser.B)() && document.dispatchEvent(new CustomEvent(KlevuDomEvents.ClickEventSent, {
          detail: {
            productId: productId,
            product: product
          }
        }));
      }
      getLastClickedLatestsFirst(n = 10, filterDuplicates = !1) {
        if (config_KlevuConfig.getDefault().disableClickTracking) return console.warn("Click tracking is disabled. Returning empty array."), 
        [];
        let clicks = Array.from(this.clicks.map((i => i.id))).reverse();
        return filterDuplicates && (clicks = clicks.filter(((item, index, self) => index === self.findIndex((t => t === item))))), 
        clicks.slice(0, n);
      }
      getProducts(n = 10) {
        return config_KlevuConfig.getDefault().disableClickTracking ? (console.warn("Click tracking is disabled. Returning empty array."), 
        []) : Array.from(this.clicks.map((i => i.product)).filter(notEmpty_notEmpty)).reverse().slice(0, n);
      }
      getCategoryPersonalisationIds(categoryPath) {
        if (config_KlevuConfig.getDefault().disableClickTracking) return console.warn("Click tracking is disabled. Returning empty array."), 
        [];
        const currentClicks = this.clicks;
        if (currentClicks.length < 3) return [];
        if (this.categoryCache && new Date(this.categoryCache.cached).getTime() > (new Date).getTime() - 36e6) return this.categoryCache.ids;
        const itemsToTake = 3 * Math.floor(currentClicks.length / 3), ids = Array.from(currentClicks).reverse().filter(((item, index, self) => index === self.findIndex((t => t.id === item.id)))).slice(0, itemsToTake).map((i => i.id));
        return this.categoryCache = {
          cached: new Date,
          ids: ids
        }, storage_KlevuStorage.addKey("klevu-last-clicks-cat"), this.saveCat(), ids;
      }
    };
    let lastSearches = [];
    if ((0, utils_isBrowser.B)()) {
      const res = storage_KlevuStorage.getItem("klevu-last-searches");
      res && (lastSearches = JSON.parse(res));
    }
    const KlevuLastSearches_save = term => {
      const lastIndex = lastSearches.findIndex((ls => ls.term === term));
      lastIndex > -1 && lastSearches.splice(lastIndex, 1), lastSearches.push({
        timestamp: (new Date).getTime(),
        term: term
      }), lastSearches.length > 10 && (lastSearches = lastSearches.slice(-10)), (0, utils_isBrowser.B)() && (document.dispatchEvent(new CustomEvent(KlevuDomEvents.LastSearchUpdate)), 
      storage_KlevuStorage.setItem("klevu-last-searches", JSON.stringify(lastSearches)));
    };
    class KlevuEvents_KlevuEvents {
      static buy({user: user, items: items}) {
        const userData = KlevuIpResolver.getDefault().getUserData(), data = {
          event: "order_purchase",
          event_version: "1.0.0",
          event_apikey: config_KlevuConfig.getDefault().apiKey,
          user_profile: Object.assign(Object.assign({}, user), {
            ip_address_v4: userData.ipv4,
            ip_address_v6: userData.ipv6,
            data_protection: config_KlevuConfig.getDefault().useConsent && config_KlevuConfig.getDefault().consentGiven,
            klevu_uuid: userData.uuid
          }),
          event_data: {
            items: items.map((i => {
              var _a, _b, _c, _d, _e, _f;
              return Object.assign({
                currency: null !== (_a = i.product.currency) && void 0 !== _a ? _a : "USD",
                item_group_id: null !== (_b = i.product.itemGroupId) && void 0 !== _b ? _b : i.product.id,
                item_id: i.product.id,
                item_name: null !== (_c = i.product.name) && void 0 !== _c ? _c : "unknown",
                item_variant_id: null !== (_d = i.variantId) && void 0 !== _d ? _d : i.product.id,
                unit_price: parseFloat(null !== (_e = i.product.salePrice) && void 0 !== _e ? _e : "0"),
                order_id: i.orderId,
                order_line_id: i.orderLineId,
                units: i.amount
              }, null !== (_f = i.override) && void 0 !== _f ? _f : {});
            }))
          }
        };
        !function(event) {
          eventRequests_awaiter(this, void 0, void 0, (function*() {
            const url = `${config_KlevuConfig.getDefault().eventsApiV2Url}`, id = addPendingRequest(url, event), res = yield fetch_post(url, [ event ], !0);
            return id && removePendingRequest(id), res;
          }));
        }(data);
      }
      static recommendationView({recommendationMetadata: recommendationMetadata, products: products, bannerInfo: bannerInfo, override: override = {}}) {
        const userData = KlevuIpResolver.getDefault().getUserData(), data = {
          event: "view_recs_list",
          event_version: "1.0.0",
          event_apikey: config_KlevuConfig.getDefault().apiKey,
          user_profile: {
            sessionId: storage_KlevuStorage.getItem("klevu-user-sessionId") || void 0,
            ip_address_v4: userData.ipv4,
            ip_address_v6: userData.ipv6,
            data_protection: config_KlevuConfig.getDefault().useConsent && config_KlevuConfig.getDefault().consentGiven,
            klevu_uuid: userData.uuid
          },
          event_data: {
            list_id: recommendationMetadata.recsKey,
            list_logic: recommendationMetadata.logic,
            list_name: recommendationMetadata.title,
            action: recommendationMetadata.action,
            spot_id: recommendationMetadata.spotKey,
            spot_name: recommendationMetadata.spotName,
            segment_name: recommendationMetadata.segmentName || void 0,
            segment_id: recommendationMetadata.segmentKey || void 0,
            static_content: bannerInfo && [ bannerInfo ],
            items: products && products.map(((p, index) => {
              var _a, _b;
              if (!p.id) throw new Error("Cannot send event without product id");
              return {
                index: index + 1,
                item_id: p.id,
                item_group_id: p.itemGroupId || p.id,
                item_name: null !== (_a = p.name) && void 0 !== _a ? _a : "unknown",
                item_variant_id: p.variantId || p.id,
                price: null !== (_b = p.price) && void 0 !== _b ? _b : "0",
                currency: p.currency,
                item_brand: p.brand,
                item_category: p.category
              };
            }))
          }
        };
        KlevuEventV2([ Object.assign(Object.assign({}, data), override) ]);
      }
      static recommendationClick({recommendationMetadata: recommendationMetadata, product: product, bannerInfo: bannerInfo, productIndexInList: productIndexInList, variantId: variantId, override: override = {}}) {
        var _a, _b;
        product && lastClickedProducts_KlevuLastClickedProducts.click(product.id, product);
        const userData = KlevuIpResolver.getDefault().getUserData(), data = {
          event: "select_recs_list",
          event_version: "1.0.0",
          event_apikey: config_KlevuConfig.getDefault().apiKey,
          user_profile: {
            sessionId: storage_KlevuStorage.getItem("klevu-user-sessionId") || void 0,
            ip_address_v4: userData.ipv4,
            ip_address_v6: userData.ipv6,
            data_protection: config_KlevuConfig.getDefault().useConsent && config_KlevuConfig.getDefault().consentGiven,
            klevu_uuid: userData.uuid
          },
          event_data: {
            list_id: recommendationMetadata.recsKey,
            list_logic: recommendationMetadata.logic,
            list_name: recommendationMetadata.title,
            action: recommendationMetadata.action,
            spot_id: recommendationMetadata.spotKey,
            spot_name: recommendationMetadata.spotName,
            static_content: bannerInfo && [ bannerInfo ],
            segment_name: recommendationMetadata.segmentName || void 0,
            segment_id: recommendationMetadata.segmentKey || void 0,
            items: product && [ {
              index: null != productIndexInList ? productIndexInList : 1,
              item_id: product.id,
              item_group_id: product.itemGroupId || product.id,
              item_name: null !== (_a = product.name) && void 0 !== _a ? _a : "unknown",
              item_variant_id: variantId || product.id,
              price: null !== (_b = product.salePrice) && void 0 !== _b ? _b : "0",
              currency: product.currency,
              item_brand: product.brand,
              item_category: product.category
            } ]
          }
        };
        KlevuEventV2([ Object.assign(Object.assign({}, data), override) ]);
      }
      static searchProductClick({product: product, searchTerm: searchTerm, variantId: variantId, activeFilters: activeFilters, tags: tags, override: override = {}}) {
        var _a, _b;
        if (!product.id) throw new Error("Cannot send event without product id");
        lastClickedProducts_KlevuLastClickedProducts.click(product.id, product);
        const userData = KlevuIpResolver.getDefault().getUserData(), data = {
          klevu_apiKey: config_KlevuConfig.getDefault().apiKey,
          klevu_type: "clicked",
          klevu_keywords: searchTerm,
          klevu_productGroupId: product.itemGroupId || product.id,
          klevu_productId: product.id,
          klevu_productName: null !== (_a = product.name) && void 0 !== _a ? _a : "unknown",
          klevu_productUrl: null !== (_b = product.url) && void 0 !== _b ? _b : "",
          klevu_productVariantId: variantId || product.id,
          klevu_activeFilters: activeFilters,
          tags: tags || [],
          klevu_shopperIP_v4: userData.ipv4,
          klevu_shopperIP_v6: userData.ipv6,
          data_protection: config_KlevuConfig.getDefault().useConsent && config_KlevuConfig.getDefault().consentGiven,
          klevu_uuid: userData.uuid
        };
        !function(event) {
          eventRequests_awaiter(this, void 0, void 0, (function*() {
            const url = `${config_KlevuConfig.getDefault().eventsApiV1Url}productTracking`, id = addPendingRequest(url, event), res = yield sendGenericPostEvent(url, event);
            return id && removePendingRequest(id), res;
          }));
        }(Object.assign(Object.assign({}, data), override));
      }
      static search({term: term, totalResults: totalResults, typeOfSearch: typeOfSearch, activeFilters: activeFilters, tags: tags, override: override = {}}) {
        KlevuLastSearches_save(term);
        const userData = KlevuIpResolver.getDefault().getUserData(), data = {
          klevu_apiKey: config_KlevuConfig.getDefault().apiKey,
          klevu_term: term,
          klevu_totalResults: totalResults,
          klevu_typeOfQuery: typeOfSearch,
          klevu_activeFilters: activeFilters,
          klevu_shopperIP_v4: userData.ipv4,
          klevu_shopperIP_v6: userData.ipv6,
          tags: tags || [],
          data_protection: config_KlevuConfig.getDefault().useConsent && config_KlevuConfig.getDefault().consentGiven,
          klevu_uuid: userData.uuid
        };
        !function(event) {
          eventRequests_awaiter(this, void 0, void 0, (function*() {
            const url = `${config_KlevuConfig.getDefault().eventsApiV1Url}n-search/search`, id = addPendingRequest(url, event), res = yield sendGenericPostEvent(url, event);
            return id && removePendingRequest(id), res;
          }));
        }(Object.assign(Object.assign({}, data), override));
      }
      static categoryMerchandisingView({categoryTitle: categoryTitle, klevuCategory: klevuCategory, products: products, pageStartsFrom: pageStartsFrom, abTestId: abTestId, abTestVariantId: abTestVariantId, activeFilters: activeFilters, override: override = {}}) {
        const userData = KlevuIpResolver.getDefault().getUserData(), data = {
          klevu_apiKey: config_KlevuConfig.getDefault().apiKey,
          klevu_categoryName: categoryTitle,
          klevu_categoryPath: klevuCategory,
          klevu_productIds: products.map((p => p.id)).join(","),
          klevu_pageStartsFrom: pageStartsFrom,
          klevu_activeFilters: activeFilters,
          klevu_abTestId: abTestId,
          klevu_abTestVariantId: abTestVariantId,
          klevu_shopperIP_v4: userData.ipv4,
          klevu_shopperIP_v6: userData.ipv6,
          data_protection: config_KlevuConfig.getDefault().useConsent && config_KlevuConfig.getDefault().consentGiven,
          klevu_uuid: userData.uuid
        };
        !function(event) {
          eventRequests_awaiter(this, void 0, void 0, (function*() {
            const url = `${config_KlevuConfig.getDefault().eventsApiV1Url}categoryProductViewTracking`, id = addPendingRequest(url, event), res = yield sendGenericPostEvent(url, event);
            return id && removePendingRequest(id), res;
          }));
        }(Object.assign(Object.assign({}, data), override));
      }
      static categoryMerchandisingProductClick({product: product, categoryTitle: categoryTitle, klevuCategory: klevuCategory, variantId: variantId, productPosition: productPosition, abTestId: abTestId, abTestVariantId: abTestVariantId, activeFilters: activeFilters, override: override = {}}) {
        if (!product.id) throw new Error("Cannot send event without product id");
        lastClickedProducts_KlevuLastClickedProducts.click(product.id, product);
        const userData = KlevuIpResolver.getDefault().getUserData(), data = {
          klevu_apiKey: config_KlevuConfig.getDefault().apiKey,
          klevu_categoryName: categoryTitle,
          klevu_productGroupId: product.itemGroupId || product.id,
          klevu_productVariantId: variantId || product.id,
          klevu_categoryPath: klevuCategory,
          klevu_productId: product.id,
          klevu_productName: product.name,
          klevu_productUrl: product.url,
          klevu_salePrice: product.salePrice,
          klevu_productSku: product.sku,
          klevu_productPosition: productPosition,
          klevu_abTestId: abTestId,
          klevu_abTestVariantId: abTestVariantId,
          klevu_activeFilters: activeFilters,
          klevu_shopperIP_v4: userData.ipv4,
          klevu_shopperIP_v6: userData.ipv6,
          data_protection: config_KlevuConfig.getDefault().useConsent && config_KlevuConfig.getDefault().consentGiven,
          klevu_uuid: userData.uuid
        };
        !function(event) {
          eventRequests_awaiter(this, void 0, void 0, (function*() {
            const url = `${config_KlevuConfig.getDefault().eventsApiV1Url}categoryProductClickTracking`, id = addPendingRequest(url, event), res = yield sendGenericPostEvent(url, event);
            return id && removePendingRequest(id), res;
          }));
        }(Object.assign(Object.assign({}, data), override));
      }
      static imageBannerClick({term: term, bannerId: bannerId, bannerName: bannerName, imageUrl: imageUrl, targetUrl: targetUrl, override: override = {}}) {
        const data = {
          klevu_apiKey: config_KlevuConfig.getDefault().apiKey,
          type: "banner",
          klevu_request: "click",
          klevu_term: term,
          klevu_bannerId: bannerId,
          klevu_bannerName: bannerName,
          klevu_image: imageUrl,
          klevu_target: targetUrl
        };
        !function(event) {
          eventRequests_awaiter(this, void 0, void 0, (function*() {
            const url = `${config_KlevuConfig.getDefault().eventsApiV1Url}dataTracking`, id = addPendingRequest(url, event), res = yield sendGenericPostEvent(url, event);
            return id && removePendingRequest(id), res;
          }));
        }(Object.assign(Object.assign({}, data), override));
      }
    }
    var applyFilter_awaiter = function(thisArg, _arguments, P, generator) {
      return new (P || (P = Promise))((function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator.throw(value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          var value;
          result.done ? resolve(result.value) : (value = result.value, value instanceof P ? value : new P((function(resolve) {
            resolve(value);
          }))).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      }));
    };
    function applyFilterWithManager(manager) {
      return function(filters) {
        const query = {
          applyFilters: {
            filters: filters
          }
        };
        return {
          klevuModifierId: "applyFilters",
          modifyAfter: queries => applyFilter_awaiter(this, void 0, void 0, (function*() {
            const copy = Array.from(queries);
            if (0 == filters.length) return copy;
            for (const q of copy) {
              const filters = Object.assign(Object.assign({}, q.filters), {
                applyFilters: query.applyFilters
              });
              q.filters = filters;
            }
            return copy;
          }))
        };
      }(manager.toApplyFilters());
    }
    var listFilters_awaiter = function(thisArg, _arguments, P, generator) {
      return new (P || (P = Promise))((function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator.throw(value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          var value;
          result.done ? resolve(result.value) : (value = result.value, value instanceof P ? value : new P((function(resolve) {
            resolve(value);
          }))).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      }));
    };
    const defaults = {
      order: KlevuFilterOrder.Index,
      limit: 10
    };
    function listFilters(options) {
      const params = Object.assign(Object.assign({}, defaults), options), query = {
        filtersToReturn: {
          enabled: !0,
          include: params.include,
          exclude: params.exclude,
          options: {
            order: params.order,
            limit: params.limit,
            mincount: params.mincount
          },
          rangeFilterSettings: params.rangeFilterSettings
        }
      };
      return {
        klevuModifierId: "listfilters",
        modifyAfter: queries => listFilters_awaiter(this, void 0, void 0, (function*() {
          const copy = Array.from(queries);
          for (const q of copy) {
            const filters = Object.assign(Object.assign({}, q.filters), {
              filtersToReturn: query.filtersToReturn
            });
            q.filters = filters;
          }
          return copy;
        })),
        onResult: result => {
          var _a, _b;
          if (!(null == options ? void 0 : options.filterManager)) return result;
          for (const qr of null !== (_b = null === (_a = result.apiResponse) || void 0 === _a ? void 0 : _a.queryResults) && void 0 !== _b ? _b : []) qr.filters && options.filterManager.initFromListFilters(qr.filters);
          return result;
        }
      };
    }
    function sendSearchEvent(override) {
      return {
        klevuModifierId: "sendSearchEvent",
        ssrOnResultFE: !0,
        onResult: (res, f) => {
          var _a;
          if (!f.params) return res;
          const {id: id, term: term} = f.params;
          if (!id || !term) return res;
          const meta = null === (_a = res.queriesById(id)) || void 0 === _a ? void 0 : _a.meta;
          return meta ? (KlevuEvents_KlevuEvents.search({
            term: term,
            totalResults: meta.totalResultsFound,
            typeOfSearch: meta.typeOfSearch,
            override: override,
            tags: meta.tags
          }), f.params || (f.params = {}), f.params.searchSendEventSent = !0, res) : res;
        }
      };
    }
    function extractActiveFilters_extractActiveFilters(result) {
      var _a;
      let selectedFiltersStr = "", isAnyFilterSelected = !1;
      if (result.filters && 0 !== result.filters.length) return null === (_a = result.filters) || void 0 === _a || _a.forEach((filter => {
        if (filter.type === KlevuFilterType.Slider) {
          if (!filter.start || !filter.end) return;
          filter.start == filter.min && filter.end == filter.max || (isAnyFilterSelected && (selectedFiltersStr += ";;"), 
          isAnyFilterSelected = !0, selectedFiltersStr += filter.key + ":" + filter.start + " - " + filter.end);
        } else filter.options.forEach((option => {
          option.selected && (isAnyFilterSelected && (selectedFiltersStr += ";;"), isAnyFilterSelected = !0, 
          selectedFiltersStr += filter.key + ":" + option.name);
        }));
      })), isAnyFilterSelected ? selectedFiltersStr : void 0;
    }
    KlevuTypeOfRequest_KlevuTypeOfRequest.AlsoBought, KlevuTypeOfRequest_KlevuTypeOfRequest.AlsoViewed, 
    KlevuTypeOfRequest_KlevuTypeOfRequest.NewArrivals, KlevuTypeOfRequest_KlevuTypeOfRequest.SimilarProducts, 
    KlevuTypeOfRequest_KlevuTypeOfRequest.Trending;
    var getAnnotationsForProduct_awaiter = function(thisArg, _arguments, P, generator) {
      return new (P || (P = Promise))((function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator.throw(value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          var value;
          result.done ? resolve(result.value) : (value = result.value, value instanceof P ? value : new P((function(resolve) {
            resolve(value);
          }))).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      }));
    };
    function getAnnotationsForProduct(response, productId, languageCode) {
      var _a;
      return getAnnotationsForProduct_awaiter(this, void 0, void 0, (function*() {
        const prod = null === (_a = response.records) || void 0 === _a ? void 0 : _a.find((s => s.id === productId));
        if (!prod) return;
        const paramaters = {
          query: response.meta.searchedTerm,
          title: prod.name,
          category: prod.category,
          languageCode: languageCode
        }, url = "https://nlp-services.ksearchnet.com/" + config_KlevuConfig.getDefault().apiKey + "/annotations" + function(params) {
          let urlData = "?";
          for (const [key, value] of Object.entries(params)) void 0 !== value && (urlData += `${key}=${encodeURIComponent(value)}&`);
          return urlData;
        }(paramaters);
        return yield fetch_get(url);
      }));
    }
    function KlevuGetBannersByType(banners, searchType, termOrCategory) {
      const dateFiltered = function(banners, date = new Date) {
        return banners.filter((banner => {
          const startDate = bannerDateToDate(banner.startDate);
          if ("" === banner.endDate) return startDate <= date;
          const endDate = bannerDateToDate(banner.endDate, !0);
          return startDate <= date && endDate >= date;
        }));
      }(banners);
      return function(banners, term) {
        return banners.filter((banner => null === banner.showForTerms || banner.showForTerms.includes(term)));
      }(dateFiltered.filter((banner => {
        switch (searchType) {
         case "landingpage":
          return banner.showOnLandingPage;

         case "quicksearch":
          return banner.showOnQuickSearch;

         case "merchandising":
          return banner.showOnCategoryPage;
        }
      })), termOrCategory);
    }
    function bannerDateToDate(date, end) {
      const [year, month, day] = date.split("/"), jsDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      return end && jsDate.setHours(23, 59, 59), jsDate;
    }
    var kmc_awaiter = function(thisArg, _arguments, P, generator) {
      return new (P || (P = Promise))((function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator.throw(value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          var value;
          result.done ? resolve(result.value) : (value = result.value, value instanceof P ? value : new P((function(resolve) {
            resolve(value);
          }))).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      }));
    };
    const url = "https://js.klevu.com/klevu-js-v1/klevu-js-api/", kmc_STORAGE_KEY = "klevu-kmc-data", kmc_STORAGE_TS_KEY = "klevu-kmc-data-ts", ONE_DAY = 864e5;
    function KlevuKMCSettings(ignoreCache, cacheLength = ONE_DAY, overrideUrl = "") {
      return kmc_awaiter(this, void 0, void 0, (function*() {
        if ((0, utils_isBrowser.B)() && window.localStorage && !0 !== ignoreCache) {
          const ts = storage_KlevuStorage.getItem(kmc_STORAGE_TS_KEY), res = storage_KlevuStorage.getItem(kmc_STORAGE_KEY);
          if (res && ts && (new Date).getTime() - parseInt(ts, 10) < cacheLength) return JSON.parse(res);
        }
        const start = `${overrideUrl || url}${config_KlevuConfig.getDefault().apiKey}`, res = yield Promise.all([ fetch_get(`${start}.json`), fetch_get(`${start}-banner.json`), fetch_get(`${start}-maps.json`) ]), data = {
          root: res[0],
          banner: res[1],
          maps: res[2]
        };
        return (0, utils_isBrowser.B)() && window.localStorage && (storage_KlevuStorage.setItem(kmc_STORAGE_KEY, JSON.stringify(data)), 
        storage_KlevuStorage.setItem(kmc_STORAGE_TS_KEY, (new Date).getTime().toString())), 
        data;
      }));
    }
    var getBanners_awaiter = function(thisArg, _arguments, P, generator) {
      return new (P || (P = Promise))((function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator.throw(value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          var value;
          result.done ? resolve(result.value) : (value = result.value, value instanceof P ? value : new P((function(resolve) {
            resolve(value);
          }))).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      }));
    };
    var getRedirects_awaiter = function(thisArg, _arguments, P, generator) {
      return new (P || (P = Promise))((function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator.throw(value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          var value;
          result.done ? resolve(result.value) : (value = result.value, value instanceof P ? value : new P((function(resolve) {
            resolve(value);
          }))).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      }));
    };
    var _KlevuResponseQueryObject_instances, _KlevuResponseQueryObject_initRedirects, _KlevuResponseQueryObject_initEventFunctions, responseQueryObject_awaiter = function(thisArg, _arguments, P, generator) {
      return new (P || (P = Promise))((function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator.throw(value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          var value;
          result.done ? resolve(result.value) : (value = result.value, value instanceof P ? value : new P((function(resolve) {
            resolve(value);
          }))).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      }));
    }, __classPrivateFieldGet = function(receiver, state, kind, f) {
      if ("a" === kind && !f) throw new TypeError("Private accessor was defined without a getter");
      if ("function" == typeof state ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
      return "m" === kind ? f : "a" === kind ? f.call(receiver) : f ? f.value : state.get(receiver);
    };
    class KlevuResponseQueryObject {
      constructor(responseObject, query, func) {
        _KlevuResponseQueryObject_instances.add(this), this.hooks = [], this.responseObject = responseObject, 
        this.query = query, this.func = func, __classPrivateFieldGet(this, _KlevuResponseQueryObject_instances, "m", _KlevuResponseQueryObject_initEventFunctions).call(this), 
        __classPrivateFieldGet(this, _KlevuResponseQueryObject_instances, "m", _KlevuResponseQueryObject_initRedirects).call(this);
      }
      get filters() {
        return this.query.filters;
      }
      get id() {
        return this.query.id;
      }
      get meta() {
        return this.query.meta;
      }
      get records() {
        return this.query.records;
      }
      get functionParams() {
        return this.func.params;
      }
      getPage(params) {
        var _a, _b, _c, _d;
        return responseQueryObject_awaiter(this, void 0, void 0, (function*() {
          const newFunc = Object.assign({}, this.func), prevQueryResponse = this.query;
          if (newFunc.queries) {
            for (let i = 0; i < newFunc.queries.length; i++) {
              const prevQuery = newFunc.queries[i];
              prevQuery.settings || (prevQuery.settings = {}), void 0 !== (null == params ? void 0 : params.pageIndex) ? prevQuery.settings.offset = prevQueryResponse.meta.noOfResults * params.pageIndex : prevQuery.settings.offset = prevQueryResponse.meta.noOfResults + prevQueryResponse.meta.offset, 
              prevQuery.settings.limit = null !== (_c = null !== (_a = null == params ? void 0 : params.limit) && void 0 !== _a ? _a : null === (_b = prevQuery.settings) || void 0 === _b ? void 0 : _b.limit) && void 0 !== _c ? _c : 5, 
              newFunc.queries[i] = prevQuery;
            }
            return (null == params ? void 0 : params.filterManager) && (newFunc.modifiers || (newFunc.modifiers = []), 
            newFunc.modifiers.push(applyFilterWithManager(params.filterManager))), newFunc.previousResultRecords = [ ...null !== (_d = this.func.previousResultRecords) && void 0 !== _d ? _d : [], ...prevQueryResponse.records ], 
            yield klevuFetch_KlevuFetch(function(f, prevQueryResult) {
              var _a;
              if (f.queries = null === (_a = f.queries) || void 0 === _a ? void 0 : _a.map((q => {
                var _a, _b;
                return (null === (_a = q.filters) || void 0 === _a ? void 0 : _a.filtersToReturn) && (null === (_b = q.filters) || void 0 === _b || delete _b.filtersToReturn), 
                q;
              })), f.modifiers) {
                const index = f.modifiers.findIndex((m => "listfilters" == m.klevuModifierId));
                index > -1 && f.modifiers.splice(index, 1), f.modifiers.push((prevQuery = prevQueryResult, 
                {
                  klevuModifierId: "injectFilteResult",
                  onResult: response => {
                    var _a, _b;
                    const copy = Object.assign({}, response), found = null === (_b = null === (_a = copy.apiResponse) || void 0 === _a ? void 0 : _a.queryResults) || void 0 === _b ? void 0 : _b.find((q => q.id === prevQuery.id));
                    return found && (found.filters = prevQuery.filters), copy;
                  }
                }));
              }
              var prevQuery;
              return f;
            }(newFunc, prevQueryResponse));
          }
        }));
      }
      hasNextPage() {
        return this.query.meta.totalResultsFound > this.query.meta.offset + this.query.meta.noOfResults;
      }
      getTotalPages() {
        return Math.ceil(this.query.meta.totalResultsFound / this.query.meta.offset);
      }
      annotationsById(productId, languageCode) {
        return getAnnotationsForProduct(this.query, productId, languageCode);
      }
      getBanners(params = {}) {
        return responseQueryObject_awaiter(this, void 0, void 0, (function*() {
          return function(responseObject, searchType) {
            var _a, _b;
            return getBanners_awaiter(this, void 0, void 0, (function*() {
              if (![ "search", "categoryMerchandising" ].includes(responseObject.func.klevuFunctionId)) return [];
              const settings = yield KlevuKMCSettings();
              if (!settings.banner) return [];
              switch (responseObject.func.klevuFunctionId) {
               case "search":
                {
                  if (!searchType) throw new Error("Search type (landingpage|quicksearch) is required for search query banners");
                  const searchTerm = null === (_a = responseObject.func.params) || void 0 === _a ? void 0 : _a.term;
                  if (!searchTerm) throw new Error("Search term is required for search query banners");
                  return KlevuGetBannersByType(settings.banner.klevu_banner, searchType, searchTerm);
                }

               case "categoryMerchandising":
                {
                  const category = null === (_b = responseObject.func.params) || void 0 === _b ? void 0 : _b.category;
                  return category ? KlevuGetBannersByType(settings.banner.klevu_banner, "merchandising", category) : [];
                }
              }
              throw new Error("Couldn't find banners for this query. Unknown query type.");
            }));
          }(this, params.searchType);
        }));
      }
      getQueryParameters() {
        return this.func.params;
      }
    }
    _KlevuResponseQueryObject_instances = new WeakSet, _KlevuResponseQueryObject_initRedirects = function() {
      "search" === this.func.klevuFunctionId && (this.getRedirects = () => {
        var _a;
        return (null === (_a = this.func.params) || void 0 === _a ? void 0 : _a.term) ? function(term) {
          return getRedirects_awaiter(this, void 0, void 0, (function*() {
            const settings = yield KlevuKMCSettings();
            return settings.maps ? settings.maps.klevu_keywordUrlMap.filter((map => map.keywords.some((k => k === term)))) : [];
          }));
        }(this.func.params.term) : Promise.resolve([]);
      });
    }, _KlevuResponseQueryObject_initEventFunctions = function() {
      var _a, _b, _c;
      switch (null === (_a = this.func) || void 0 === _a ? void 0 : _a.klevuFunctionId) {
       case "search":
        this.searchClickEvent = function({productId: productId, variantId: variantId, autoSendViewEvent: autoSendViewEvent = !0, override: override}) {
          var _a, _b, _c;
          if (!this.func) return;
          autoSendViewEvent && !(null === (_a = this.func.params) || void 0 === _a ? void 0 : _a.searchSendEventSent) && (KlevuEvents_KlevuEvents.search({
            term: this.query.meta.searchedTerm,
            totalResults: this.query.meta.noOfResults,
            typeOfSearch: this.query.meta.typeOfSearch,
            activeFilters: extractActiveFilters_extractActiveFilters(this.query),
            override: override,
            tags: this.query.meta.tags
          }), this.func.params || (this.func.params = {}), this.func.params.searchSendEventSent = !0);
          const record = [ ...this.query.records, ...null !== (_b = this.func.previousResultRecords) && void 0 !== _b ? _b : [] ].find((r => r.id === productId));
          if (!record) throw new Error(`KlevuEvents: Given "${productId}" doesn't exists in this.querys`);
          KlevuEvents_KlevuEvents.searchProductClick({
            product: record,
            searchTerm: this.query.meta.searchedTerm,
            variantId: variantId,
            tags: this.query.meta.tags
          });
          for (const hook of null !== (_c = this.hooks) && void 0 !== _c ? _c : []) hook({
            type: "search",
            productId: productId,
            variantId: variantId
          });
        };
        break;

       case "categoryMerchandising":
        this.categoryMerchandisingClickEvent = function({productId: productId, categoryTitle: categoryTitle, variantId: variantId, override: override}) {
          var _a, _b, _c, _d, _e, _f;
          if (!this.func) return;
          const record = [ ...this.query.records, ...null !== (_a = this.func.previousResultRecords) && void 0 !== _a ? _a : [] ].find((r => r.id === productId));
          if (!record) throw new Error(`KlevuEvents: Given "${productId}" doesn't exists in this.querys`);
          const index = this.query.records.findIndex((r => r.id === productId)), q = null === (_b = this.func.queries) || void 0 === _b ? void 0 : _b.find((q => {
            var _a, _b;
            return Boolean(null === (_b = null === (_a = q.settings) || void 0 === _a ? void 0 : _a.query) || void 0 === _b ? void 0 : _b.categoryPath);
          }));
          let abTestId, abTestVariantId;
          this.func.params || (this.func.params = {}), this.func.params.abtest && (abTestId = this.func.params.abtest.abTestId, 
          abTestVariantId = this.func.params.abtest.abTestVariantId), KlevuEvents_KlevuEvents.categoryMerchandisingProductClick({
            product: record,
            categoryTitle: categoryTitle,
            klevuCategory: null !== (_e = null === (_d = null === (_c = null == q ? void 0 : q.settings) || void 0 === _c ? void 0 : _c.query) || void 0 === _d ? void 0 : _d.categoryPath) && void 0 !== _e ? _e : "unknown",
            variantId: variantId,
            productPosition: (this.query.meta.offset || 0) + index + 1,
            abTestId: abTestId,
            abTestVariantId: abTestVariantId,
            activeFilters: extractActiveFilters_extractActiveFilters(this.query),
            override: override
          });
          for (const hook of null !== (_f = this.hooks) && void 0 !== _f ? _f : []) hook({
            type: "categoryMerchandising",
            productId: productId,
            variantId: variantId
          });
        };
        break;

       case "kmcRecommendation":
        {
          if (!(null === (_b = this.func.params) || void 0 === _b ? void 0 : _b.kmcConfig)) break;
          const config = null === (_c = this.func.params) || void 0 === _c ? void 0 : _c.kmcConfig;
          if ("HIDE_RECOMMENDATION" === config.metadata.action) break;
          if ("STATIC_CONTENT" === config.metadata.action) {
            if (!config.staticContent) break;
            this.recommendationBannerClickEvent = function({resolution: resolution}) {
              var _a;
              if (!config.staticContent || 0 === config.staticContent.length) return;
              const image = null !== (_a = config.staticContent[0].image.find((image => image.resolution === resolution))) && void 0 !== _a ? _a : config.staticContent[0].image[0];
              image && KlevuEvents_KlevuEvents.recommendationClick({
                recommendationMetadata: config.metadata,
                bannerInfo: {
                  resolution: resolution,
                  index: 1,
                  banner_alt_tag: image.altTag,
                  banner_image_url: image.url,
                  content_type: "image"
                }
              });
            };
            break;
          }
          this.recommendationClickEvent = function({productId: productId, variantId: variantId, override: override}) {
            var _a, _b;
            if (!this.func) return;
            const record = [ ...this.query.records, ...null !== (_a = this.func.previousResultRecords) && void 0 !== _a ? _a : [] ].find((r => r.id === productId));
            if (!record) throw new Error(`KlevuEvents: Given "${productId}" doesn't exists in this.querys`);
            if (!config) throw new Error("KlevuEvents: Recommendation kmcConfig not available");
            const index = this.query.records.findIndex((r => r.id === productId));
            KlevuEvents_KlevuEvents.recommendationClick({
              recommendationMetadata: config.metadata,
              product: record,
              productIndexInList: index + 1,
              variantId: variantId,
              override: override
            });
            for (const hook of null !== (_b = this.hooks) && void 0 !== _b ? _b : []) hook({
              type: "recommendation",
              productId: productId,
              variantId: variantId
            });
          };
        }
      }
    };
    var _KlevuResponseObject_instances, _KlevuResponseObject_functions, _KlevuResponseObject_queryObjects, _KlevuResponseObject_buildQueryObjects, __classPrivateFieldSet = function(receiver, state, value, kind, f) {
      if ("m" === kind) throw new TypeError("Private method is not writable");
      if ("a" === kind && !f) throw new TypeError("Private accessor was defined without a setter");
      if ("function" == typeof state ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
      return "a" === kind ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), 
      value;
    }, responseObject_classPrivateFieldGet = function(receiver, state, kind, f) {
      if ("a" === kind && !f) throw new TypeError("Private accessor was defined without a getter");
      if ("function" == typeof state ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
      return "m" === kind ? f : "a" === kind ? f.call(receiver) : f ? f.value : state.get(receiver);
    };
    class responseObject_KlevuResponseObject {
      constructor(response, functions, options, checkProcessedFunctions) {
        if (_KlevuResponseObject_instances.add(this), _KlevuResponseObject_functions.set(this, void 0), 
        _KlevuResponseObject_queryObjects.set(this, {}), this.apiResponse = response, __classPrivateFieldSet(this, _KlevuResponseObject_functions, functions, "f"), 
        checkProcessedFunctions && this.packProcessedFunctionsToString() !== checkProcessedFunctions) throw new Error("Processed functions are not the same as on the backend");
        responseObject_classPrivateFieldGet(this, _KlevuResponseObject_instances, "m", _KlevuResponseObject_buildQueryObjects).call(this);
        for (const f of functions) if (f.modifiers) for (const modifier of f.modifiers) modifier.onResult && (!(null == options ? void 0 : options.params.isSSR) || options.params.isSSR && !modifier.ssrOnResultFE || (null == options ? void 0 : options.params.FEHydrate) && modifier.ssrOnResultFE) && modifier.onResult(this, f);
      }
      suggestionsById(id) {
        var _a;
        return null === (_a = this.apiResponse.suggestionResults) || void 0 === _a ? void 0 : _a.find((q => q.id === id));
      }
      queriesById(id) {
        if (!responseObject_classPrivateFieldGet(this, _KlevuResponseObject_queryObjects, "f")[id]) throw new Error(`Query with id ${id} not found`);
        return responseObject_classPrivateFieldGet(this, _KlevuResponseObject_queryObjects, "f")[id];
      }
      queryExists(id) {
        return !!responseObject_classPrivateFieldGet(this, _KlevuResponseObject_queryObjects, "f")[id];
      }
      packProcessedFunctionsToString() {
        return responseObject_classPrivateFieldGet(this, _KlevuResponseObject_functions, "f").map((f => {
          var _a, _b;
          return `${f.klevuFunctionId},${null === (_a = f.queries) || void 0 === _a ? void 0 : _a.map((q => q.id))},${null === (_b = f.modifiers) || void 0 === _b ? void 0 : _b.map((m => m.klevuModifierId))}`;
        })).join(";");
      }
    }
    _KlevuResponseObject_functions = new WeakMap, _KlevuResponseObject_queryObjects = new WeakMap, 
    _KlevuResponseObject_instances = new WeakSet, _KlevuResponseObject_buildQueryObjects = function() {
      var _a;
      for (const q of null !== (_a = this.apiResponse.queryResults) && void 0 !== _a ? _a : []) {
        const func = responseObject_classPrivateFieldGet(this, _KlevuResponseObject_functions, "f").find((f => {
          var _a;
          return null === (_a = f.queries) || void 0 === _a ? void 0 : _a.some((qu => q.id == qu.id || q.id == `${qu.id}-fallback`));
        }));
        func && (responseObject_classPrivateFieldGet(this, _KlevuResponseObject_queryObjects, "f")[q.id] = new KlevuResponseQueryObject(this, q, func));
      }
    };
    var klevuFetch_awaiter = function(thisArg, _arguments, P, generator) {
      return new (P || (P = Promise))((function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator.throw(value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          var value;
          result.done ? resolve(result.value) : (value = result.value, value instanceof P ? value : new P((function(resolve) {
            resolve(value);
          }))).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      }));
    };
    const klevuFetchCache = new class {
      constructor() {
        this._cache = new Map, this._timestamp = new Map;
      }
      check(key, force = !1) {
        if (!force && !(0, utils_isBrowser.B)()) return;
        const hash = this.hash(key);
        if (!this._cache.has(hash)) return;
        const cached = this._cache.get(hash), ts = this._timestamp.get(hash);
        if (cached && ts) {
          if ((new Date).getTime() < ts) return JSON.parse(cached);
          this._cache.delete(hash), this._timestamp.delete(hash);
        }
      }
      cache(key, data, timetocache = config_KlevuConfig.getDefault().cacheMaxTTL) {
        const hash = this.hash(key);
        this._cache.set(hash, JSON.stringify(data)), this._timestamp.set(hash, (new Date).getTime() + timetocache);
      }
      hash(input) {
        return Array.from(JSON.stringify(input)).reduce(((s, c) => Math.imul(31, s) + c.charCodeAt(0) | 0), 0);
      }
    };
    class klevuFetch_KlevuFetchOption {
      constructor(params = {}) {
        this.params = params;
      }
    }
    function klevuFetch_KlevuFetch(...functionPromises) {
      var _a, _b, _c, _d, _e;
      return klevuFetch_awaiter(this, void 0, void 0, (function*() {
        if (functionPromises.length < 1) throw new Error("At least one fetch function should be provided to fetch.");
        const option = functionPromises.find((f => f instanceof klevuFetch_KlevuFetchOption)), functionPromisesWithoutOptions = functionPromises.filter((f => !(f instanceof klevuFetch_KlevuFetchOption))), functions = yield Promise.all(functionPromisesWithoutOptions), {recordQueries: recordQueries, suggestionQueries: suggestionQueries} = yield function(functions) {
          return klevuFetch_awaiter(this, void 0, void 0, (function*() {
            const recordQueries = [], suggestionQueries = [];
            for (const f of functions) {
              if (f.queries) {
                let qs = [ ...f.queries ];
                if (f.modifiers) for (const modifier of f.modifiers) modifier.modifyAfter && (qs = yield modifier.modifyAfter(qs, f));
                recordQueries.push(...qs);
              }
              f.suggestions && suggestionQueries.push(...f.suggestions);
            }
            for (const query of recordQueries) if (1 !== recordQueries.filter((q => q.id === query.id)).length) throw new Error("Duplicate ids in request. Please provider unique ids for requests");
            return {
              recordQueries: recordQueries,
              suggestionQueries: suggestionQueries
            };
          }));
        }(functions), withOverride = functions.find((f => Boolean(f.configOverride))), payload = {
          context: {
            apiKeys: [ null !== (_b = null === (_a = null == withOverride ? void 0 : withOverride.configOverride) || void 0 === _a ? void 0 : _a.apiKey) && void 0 !== _b ? _b : config_KlevuConfig.getDefault().apiKey ]
          },
          recordQueries: recordQueries.length > 0 ? recordQueries : void 0,
          suggestions: suggestionQueries.length > 0 ? suggestionQueries : void 0
        }, cached = klevuFetchCache.check(payload);
        let response;
        if (recordQueries.filter((q => q.typeOfRequest !== KlevuTypeOfRequest_KlevuTypeOfRequest.Skip)).length > 0 || suggestionQueries.length > 0) if (cached) response = cached; else {
          const res = yield fetch_post(null !== (_d = null === (_c = null == withOverride ? void 0 : withOverride.configOverride) || void 0 === _c ? void 0 : _c.url) && void 0 !== _d ? _d : config_KlevuConfig.getDefault().url, payload);
          if (!res) throw new Error("Couldn't fetch data");
          response = res, 200 == (null === (_e = res.meta) || void 0 === _e ? void 0 : _e.responseCode) && klevuFetchCache.cache(payload, response);
        }
        return new responseObject_KlevuResponseObject(null != response ? response : {
          meta: {
            qTime: 0,
            responseCode: 204
          },
          queryResults: recordQueries.map((r => ({
            id: r.id,
            meta: {},
            records: []
          }))),
          suggestionResults: []
        }, functions, option);
      }));
    }
    KlevuTypeOfRecord_KlevuTypeOfRecord.Product;
    const search_defaults = {
      id: "search",
      limit: 5,
      typeOfRecords: [ KlevuTypeOfRecord_KlevuTypeOfRecord.Product ]
    };
    function search(term, options, ...modifiers) {
      const params = Object.assign(Object.assign({}, search_defaults), options), cleanedTerm = cleanSearchQuery(term), query = {
        id: params.id,
        typeOfRequest: KlevuTypeOfRequest_KlevuTypeOfRequest.Search,
        settings: Object.assign({
          query: {
            term: cleanedTerm
          }
        }, params)
      };
      return {
        klevuFunctionId: "search",
        params: Object.assign(Object.assign({}, params), {
          term: term
        }),
        queries: [ query ],
        modifiers: modifiers
      };
    }
    const suggestions_defaults = {
      id: "suggestions",
      limit: 5
    };
    function suggestions(term, options) {
      const params = Object.assign(Object.assign({}, suggestions_defaults), options);
      return {
        klevuFunctionId: "suggestions",
        suggestions: [ Object.assign({
          typeOfRequest: KlevuTypeOfRequest_KlevuTypeOfRequest.Suggestion,
          query: cleanSearchQuery(term)
        }, params) ]
      };
    }
    function trendingProducts(options, ...modifiers) {
      return search("*", Object.assign({
        id: "trendingProducts",
        typeOfRecords: [ KlevuTypeOfRecord_KlevuTypeOfRecord.Product ]
      }, options), ...modifiers);
    }
    function searchCategory(term, options) {
      return search(term, Object.assign({
        typeOfRecords: [ KlevuTypeOfRecord_KlevuTypeOfRecord.Category ],
        groupBy: "name"
      }, options));
    }
    function searchCms(term, options) {
      return search(term, Object.assign({
        typeOfRecords: [ KlevuTypeOfRecord_KlevuTypeOfRecord.Cms ],
        groupBy: "name"
      }, options));
    }
    var KMCRecommendationPagetype, KMCRecommendationLogic;
    !function(KMCRecommendationPagetype) {
      KMCRecommendationPagetype.Home = "HOME", KMCRecommendationPagetype.Category = "CATEGORY", 
      KMCRecommendationPagetype.Product = "PRODUCT", KMCRecommendationPagetype.Checkout = "CHECKOUT";
    }(KMCRecommendationPagetype || (KMCRecommendationPagetype = {})), function(KMCRecommendationLogic) {
      KMCRecommendationLogic.Trending = "TRENDING", KMCRecommendationLogic.TrendingPersonalized = "TRENDING_PERSONALIZED", 
      KMCRecommendationLogic.NewestArrivals = "NEWEST_ARRIVALS", KMCRecommendationLogic.RecentlyViewed = "RECENTLY_VIEWED", 
      KMCRecommendationLogic.HandPicked = "HAND_PICKED", KMCRecommendationLogic.OtherAlsoViewed = "OTHER_ALSO_VIEWED", 
      KMCRecommendationLogic.Similar = "SIMILAR", KMCRecommendationLogic.BoughtTogether = "BOUGHT_TOGETHER", 
      KMCRecommendationLogic.BoughtTogetherPDP = "BOUGHT_TOGETHER_PDP", KMCRecommendationLogic.VisuallySimilar = "VISUALLY_SIMILAR", 
      KMCRecommendationLogic.Custom = "CUSTOM_LOGIC";
    }(KMCRecommendationLogic || (KMCRecommendationLogic = {}));
    class FilterManager {
      get options() {
        return this.filters.filter((filter => filter.type === KlevuFilterType.Options));
      }
      get sliders() {
        return this.filters.filter((filter => filter.type === KlevuFilterType.Slider));
      }
      constructor(initialValues) {
        var _a;
        this.filters = [], this.filters = null !== (_a = null == initialValues ? void 0 : initialValues.filters) && void 0 !== _a ? _a : [];
      }
      initFromListFilters(filters) {
        this.filters = filters, (0, utils_isBrowser.B)() && document.dispatchEvent(new CustomEvent(KlevuDomEvents.FiltersApplied, {
          detail: {
            filters: this.filters
          }
        }));
      }
      clear() {
        this.filters = [];
      }
      getCurrentState() {
        return {
          filters: this.filters
        };
      }
      setState(state) {
        this.filters = state.filters;
      }
      toggleOption(key, value) {
        const suboption = this.getOptionByKeyCreateIfNotExists(key, value), prevSeleted = suboption.selected;
        suboption.selected = !suboption.selected, (0, utils_isBrowser.B)() && document.dispatchEvent(new CustomEvent(KlevuDomEvents.FilterSelectionUpdate, {
          detail: {
            key: key,
            name: value,
            selected: !prevSeleted
          }
        }));
      }
      selectOption(key, value, fireEvent = !0) {
        this.getOptionByKeyCreateIfNotExists(key, value).selected = !0, (0, utils_isBrowser.B)() && fireEvent && document.dispatchEvent(new CustomEvent(KlevuDomEvents.FilterSelectionUpdate, {
          detail: {
            key: key,
            name: value,
            selected: !0
          }
        }));
      }
      deselectOption(key, value) {
        this.getOptionByKeyCreateIfNotExists(key, value).selected = !1, (0, utils_isBrowser.B)() && document.dispatchEvent(new CustomEvent(KlevuDomEvents.FilterSelectionUpdate, {
          detail: {
            key: key,
            name: value,
            selected: !1
          }
        }));
      }
      clearOptionSelections(key, fireEvent = !0) {
        if (key) {
          const option = this.filters.find((o => o.key === key));
          option && FilterManager.isKlevuFilterResultOptions(option) && option.options.forEach((o => o.selected = !1));
        } else this.filters.forEach((option => {
          option && FilterManager.isKlevuFilterResultOptions(option) && option.options.forEach((o2 => o2.selected = !1));
        })), (0, utils_isBrowser.B)() && fireEvent && document.dispatchEvent(new CustomEvent(KlevuDomEvents.FilterSelectionUpdate));
      }
      updateSlide(key, min, max, fireEvent = !0) {
        const slideIndex = this.filters.findIndex((s => s.key === key));
        let slider;
        if (-1 === slideIndex) slider = {
          key: key,
          end: max.toString(),
          start: min.toString(),
          min: min.toString(),
          max: max.toString(),
          label: key,
          type: KlevuFilterType.Slider
        }, this.filters.push(slider); else {
          if (!FilterManager.isKlevuFilterResultSlider(this.filters[slideIndex])) throw new Error(`Filter ${key} is not a slider filter.`);
          slider = this.filters[slideIndex], slider.start = min.toString(), slider.end = max.toString();
        }
        (0, utils_isBrowser.B)() && fireEvent && document.dispatchEvent(new CustomEvent(KlevuDomEvents.FilterSelectionUpdate, {
          detail: {
            key: key,
            name: slider.label,
            start: min.toString(),
            end: max.toString()
          }
        }));
      }
      toApplyFilters() {
        const filters = [];
        for (const filter of this.filters) if (FilterManager.isKlevuFilterResultOptions(filter) || FilterManager.isKlevuFilterResultRating(filter)) {
          const selected = filter.options.filter((subOption => !0 === subOption.selected));
          if (0 === selected.length) continue;
          filters.push({
            key: filter.key,
            values: selected.map((s => s.value)),
            settings: {
              singleSelect: !1
            }
          });
        } else if (FilterManager.isKlevuFilterResultSlider(filter)) {
          if (!filter.start || !filter.end) continue;
          filters.push({
            key: filter.key,
            values: [ filter.start, filter.end ],
            settings: {
              singleSelect: !1
            }
          });
        }
        return filters;
      }
      currentSelection(key) {
        const opt = this.filters.find((o => o.key === key));
        if (opt && (FilterManager.isKlevuFilterResultOptions(opt) || FilterManager.isKlevuFilterResultRating(opt))) {
          return opt.options.filter((subOpt => !0 === subOpt.selected)).map((s => s.value));
        }
        if (opt && FilterManager.isKlevuFilterResultSlider(opt) && opt.start && opt.end) return [ opt.start, opt.end ];
      }
      toURLParams(searchParams) {
        const params = searchParams || new URLSearchParams;
        for (const filter of this.filters) if (FilterManager.isKlevuFilterResultOptions(filter) || FilterManager.isKlevuFilterResultRating(filter)) {
          const selected = filter.options.filter((subOption => !0 === subOption.selected));
          if (0 === selected.length) {
            params.delete(`o_${filter.key}`);
            continue;
          }
          params.set(`o_${filter.key}`, selected.map((s => s.value)).join(","));
        } else if (FilterManager.isKlevuFilterResultSlider(filter)) {
          if (!filter.start || !filter.end) {
            params.delete(`s_${filter.key}`);
            continue;
          }
          params.set(`s_${filter.key}`, `${filter.start}-${filter.end}`);
        }
        for (const [key] of params.entries()) if (key.startsWith("o_") || key.startsWith("s_")) {
          const filterKey = key.substring(2);
          this.filters.find((f => f.key === filterKey)) || params.delete(key);
        }
        return params.toString();
      }
      readFromURLParams(params) {
        this.clearOptionSelections(void 0, !1);
        for (const [key, value] of params.entries()) if (key.startsWith("o")) {
          const optionKey = key.substring(2);
          value.split(",").forEach((v => this.selectOption(optionKey, v, !1)));
        } else if (key.startsWith("s")) {
          const sliderKey = key.substring(2);
          this.updateSlide(sliderKey, parseFloat(value.split("-")[0]), parseFloat(value.split("-")[1]), !1);
        }
        (0, utils_isBrowser.B)() && document.dispatchEvent(new CustomEvent(KlevuDomEvents.FiltersApplied, {
          detail: {
            filters: this.filters
          }
        }));
      }
      selectedFilters() {
        const selectedFilters = [];
        for (const filter of this.filters) if (FilterManager.isKlevuFilterResultOptions(filter) || FilterManager.isKlevuFilterResultRating(filter)) {
          const selected = filter.options.filter((subOption => !0 === subOption.selected));
          if (0 === selected.length) continue;
          for (const option of selected) selectedFilters.push({
            key: filter.key,
            label: filter.label,
            type: filter.type,
            value: option.value
          });
        } else if (FilterManager.isKlevuFilterResultSlider(filter)) {
          if (!filter.start || !filter.end) continue;
          selectedFilters.push({
            key: filter.key,
            label: filter.label,
            type: filter.type,
            value: `${filter.start}-${filter.end}`
          });
        }
        return selectedFilters;
      }
      getOptionByKeyCreateIfNotExists(key, value) {
        const optionIndex = this.filters.findIndex((o => o.key === key));
        let option;
        if (-1 === optionIndex) option = {
          key: key,
          label: key,
          options: [],
          type: KlevuFilterType.Options
        }, this.filters.push(option); else {
          if (!FilterManager.isKlevuFilterResultOptions(this.filters[optionIndex]) && !FilterManager.isKlevuFilterResultRating(this.filters[optionIndex])) throw new Error(`Filter ${key} is not an option filter.`);
          option = this.filters[optionIndex];
        }
        const subOptionIndex = option.options.findIndex((o => o.value === value));
        return -1 === subOptionIndex ? (option.options.push({
          count: 1,
          name: value,
          selected: !1,
          value: value
        }), option.options[option.options.length - 1]) : option.options[subOptionIndex];
      }
      static isKlevuFilterResultSlider(filter) {
        return filter.type === KlevuFilterType.Slider;
      }
      static isKlevuFilterResultOptions(filter) {
        return filter.type === KlevuFilterType.Options;
      }
      static isKlevuFilterResultRating(filter) {
        return filter.type === KlevuFilterType.Rating;
      }
    }
  },
  345: function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
    __webpack_require__.d(__webpack_exports__, {
      B: function() {
        return isBrowser;
      }
    });
    const isBrowser = () => ![ typeof window, typeof document ].includes("undefined");
  }
} ]);